import React, { ReactNode } from "react"
import styles from "./AppFooter.module.scss"
import { AppLogo } from "components/common/AppLogo"
import { NavLink } from "react-router-dom"


export const AppFooter = () => {
    return (
        <footer className={styles.appFooter}>
            <AppLogo/>
            <TextLink>Пользовательское соглашение</TextLink>
            <TextLink>Политика конфиденциальности</TextLink>
        </footer>
    )
}


const TextLink = ({children} : {children: ReactNode}) => {
    return (
        <NavLink className={styles.text} to="/faq">
            { children }
        </NavLink>
    )
}